import { AxiosError } from "axios";
import api, { API_VERSIONS } from "@/config/api";
import { Transcription } from "@/models/recording";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { appLogger } from "@/utils/AppLogger";

const eventName = "PATCH-RECORDING-DATA";

interface PatchRecordingDataPayload {
  recordingId: string;
  status?: number;
  transcript?: Transcription;
  duration?: string;
}

const patchRecordingData = async ({ recordingId, duration, status, transcript }: PatchRecordingDataPayload): Promise<string | AxiosError> => {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.patch<string, PatchRecordingDataPayload>(
      `/${API_VERSIONS.v0}/recording`,
      {
        recordingId,
        ...(duration !== undefined ? { duration } : {}),
        ...(status !== undefined ? { status } : {}),
        ...(transcript !== undefined ? { transcript } : {}),
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${initialToken}`,
        },
      },
    );
    return res.data;
  } catch (error) {
    appLogger(`[PATCH RECORDING DATA] Error patching recording data: ${error}`, {
      type: "error",
      errorReportOptions: { eventName, properties: { recordingId } },
    });
    throw error;
  }
};

export default patchRecordingData;
